import { ClientFactories } from 'bernie-plugin-mobx';

import { AdvertisingStore } from 'bernie-plugin-ads-loader-script';
import { ClientLogger } from 'bernie-client';
import { ContextInput } from 'bernie-context';
import { ContextStore, Store } from 'bernie-core';
import { NOOP_LOGGER } from 'bernie-logger';

import { BexApiSource } from 'sources/bex-api-source';

import { CurrentHotelStore } from './current-hotel-store';
import { MultiItemStore } from './multi-item-store';
import { PageLayoutStore } from './page-layout-store';
import { QualtricsStore } from './qualtrics-store';
import { SearchCriteriaStore } from './search-criteria-store';
import { SearchResultsStore } from './search-results-store';
import { UIPageStore } from './ui-page-store';
import { VirtualAgentControlStore } from './virtual-agent-control-store';

export const buildBexApiSource = (contextInput: ContextInput): BexApiSource => {
  const headers = { 'Device-User-Agent-ID': contextInput.identity.duaid };

  return new BexApiSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.bexapi'), headers);
};

export const stores: ClientFactories = {
  advertising: (): Store => new AdvertisingStore({}, ClientLogger.getLoggerWithIdentifier('pwa.store.advertising')),
  virtualAgentControlStore: (): Store =>
    new VirtualAgentControlStore({}, ClientLogger.getLoggerWithIdentifier('pwa.store.virtualagentcontrol')),

  context: (): Store => new ContextStore(null, NOOP_LOGGER),

  currentHotel: ({ bexApiContext, l10n }): Store =>
    new CurrentHotelStore(buildBexApiSource(bexApiContext), {}, l10n, ClientLogger.getLoggerWithIdentifier('pwa.store.currenthotel')),
  searchCriteria: ({ l10n }): Store => new SearchCriteriaStore({}, l10n, ClientLogger.getLoggerWithIdentifier('pwa.store.searchcriteria')),

  searchResults: ({ bexApiContext }): Store =>
    new SearchResultsStore(buildBexApiSource(bexApiContext), {}, ClientLogger.getLoggerWithIdentifier('pwa.store.searchresults')),

  multiItem: ({ bexApiContext, l10n }): Store =>
    new MultiItemStore(buildBexApiSource(bexApiContext), {}, ClientLogger.getLoggerWithIdentifier('pwa.store.multiitem'), l10n),
  pageLayout: ({ bexApiContext }): Store =>
    new PageLayoutStore(buildBexApiSource(bexApiContext), {}, ClientLogger.getLoggerWithIdentifier('pwa.store.pagelayout')),
  qualtrics: (): Store => new QualtricsStore({}),
  uiPage: (): Store => new UIPageStore({}),
};
